import { axios } from '../../../lib/axios';

export const likePost = async (key: string) => {
  return await axios.post(`posts/${key}/like`);
};
